<template lang="pug">
v-container.pa-0(grid-list-xl, fluid)
  v-layout(wrap)
    v-flex(xs6)
      b-text(:block='getBlock()', @update='setBlock($event)')
    v-flex(xs6)
      .handler
        s-editor-image-upload(
          :src='block.value.image.url',
          :ratio='null',
          label='Нажмите для загрузки картинки',
          @upload-success='updateImage',
          @click-image='openDialog'
        )
        .edit(v-if='block.value.image.url')
          v-btn(@click='openDialog', icon, depressed, color='white')
            v-icon edit
  v-dialog(v-model='editDialog', width='280')
    v-card
      v-form(@submit='closeDialog')
        .pa-3
          v-text-field(
            label='Название',
            v-model='block.value.image.name',
            @input='$emit("update", block)'
          )
</template>

<script>
import BaseBlock from './BaseBlock'
import Text from './Text'
import PropTypes from '@znck/prop-types'

export default {
  extends: BaseBlock,

  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
        image: PropTypes.shape({
          src: PropTypes.string,
          hash: PropTypes.string,
        }),
      }),
    }),
  },

  data: () => ({
    editDialog: false,
  }),

  components: { BText: Text },

  methods: {
    getBlock() {
      const value = this.block.value.text
      return { value: value || '', type: 'text' }
    },

    setBlock(block) {
      this.block.value.text = block.value
      this.$emit('update', this.block)
    },

    updateImage({ url, hash }) {
      this.block.value.image.url = url
      this.block.value.image.hash = hash
      this.$emit('update', this.block)
      this.$forceUpdate()
    },

    closeDialog(ev) {
      ev.preventDefault()
      this.editDialog = false
    },

    openDialog() {
      this.editDialog = true
    },
  },
}
</script>

<style scoped>
.textarea {
  padding-left: 48px;
}
.handler {
  position: relative;
}
.edit {
  bottom: 24px;
  right: 12px;
  position: absolute;
}
</style>
